import type { TFunction } from "i18next";
import * as APITypes from "~/API";

/** Duration order for Ant Design lease-type column sorters (shorter → longer). */
export const LEASE_TYPE_ORDER: Record<APITypes.LeaseTypeOptions, number> = {
  [APITypes.LeaseTypeOptions.Monthly]: 1,
  [APITypes.LeaseTypeOptions.ThreeMonths]: 2,
  [APITypes.LeaseTypeOptions.SixMonths]: 3,
  [APITypes.LeaseTypeOptions.OneYear]: 4,
  [APITypes.LeaseTypeOptions.TwoYears]: 5,
  [APITypes.LeaseTypeOptions.ThreeYears]: 6,
};

/**
 * Human-readable lease type for UI (matches `LeaseTypeTag` labels).
 */
export function translateLeaseTypeOption(
  type: APITypes.LeaseTypeOptions | string | undefined | null,
  t: TFunction,
): string {
  if (type == null || type === "") {
    return "—";
  }
  switch (type as APITypes.LeaseTypeOptions) {
    case APITypes.LeaseTypeOptions.ThreeYears:
      return t("3_years");
    case APITypes.LeaseTypeOptions.TwoYears:
      return t("2_years");
    case APITypes.LeaseTypeOptions.OneYear:
      return t("1_year");
    case APITypes.LeaseTypeOptions.SixMonths:
      return t("6_months");
    case APITypes.LeaseTypeOptions.ThreeMonths:
      return t("3_months");
    case APITypes.LeaseTypeOptions.Monthly:
      return t("Monthly");
    default:
      return String(type);
  }
}
